<div class="modal-overlay" (click)="onBackdropClick()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-header-title">
        <div class="modal-icon success">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <line x1="19" y1="8" x2="19" y2="14"></line>
            <line x1="22" y1="11" x2="16" y2="11"></line>
          </svg>
        </div>
        <h2 class="modal-title">{{ step() !== 'success' ? 'Anmeldung bestätigen' : (waitlisted() ? 'Auf der Warteliste' : 'Anmeldung erfolgreich') }}</h2>
      </div>
      <button type="button" class="close-btn" aria-label="Schließen" (click)="step() === 'success' ? closeModal() : onCancel()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Enrollment Step -->
    @if (step() === 'enrollment') {
      <!-- Session Details -->
      <div class="modal-content">
        <div class="session-summary">
          <div class="summary-row">
            <span class="summary-label">{{ kindLabel }}</span>
            <span class="summary-value">{{ session.displayName }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">Datum</span>
            <span class="summary-value">{{ formatDate(getSessionStartTime()) }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">Uhrzeit</span>
            <span class="summary-value">{{ formatTime(getSessionStartTime()) }} - {{ formatTime(getSessionEndTime()) }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">Platz</span>
            <span class="summary-value">{{ getCourtNames(session) }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">Preis</span>
            <span class="summary-value price-highlight">
              @if (isFreeSession()) {
                Kostenlos
              } @else {
                {{ getSessionPrice() | currency:'EUR':'symbol':'1.2' }}
              }
            </span>
          </div>
        </div>

        <!-- Availability Indicator -->
        <div class="availability-section">
          <div class="spots-indicator"
               [class.plenty]="getAvailabilityLevel() === 'plenty'"
               [class.limited]="getAvailabilityLevel() === 'limited'"
               [class.scarce]="getAvailabilityLevel() === 'scarce'">
            <div class="spots-header">
              <span class="spots-label">Verfügbarkeit</span>
              <span class="spots-text">{{ session.availableSpots }} Plätze übrig</span>
            </div>
            <div class="spots-bar">
              <div class="spots-bar-fill" [style.width.%]="getFillPercentage()"></div>
            </div>
          </div>
        </div>

        <!-- User info (if logged in) -->
        @if (getCurrentUser(); as user) {
          <div class="user-info">
            <h3 class="section-title">Deine Daten</h3>
            <div class="user-detail">
              <span class="detail-label">Name</span>
              <span class="detail-value">{{ user.username }}</span>
            </div>
            <div class="user-detail">
              <span class="detail-label">E-Mail</span>
              <span class="detail-value">{{ user.email }}</span>
            </div>
          </div>
        }

        <!-- Shared Payment Section (vouchers + payment options).
             Suppressed for a free session: there is no amount to pay, so a
             payment-method picker and a voucher list would both be noise.

             Otherwise it waits for the per-session on-site verdict from
             `GET /sessions/:id`. Rendering the picker before that answer
             arrives would show a guess: `onSitePaymentEnabled` is still at its
             fail-safe `false`, so a session an admin explicitly opened would
             flash "Keine Zahlungsmethode verfügbar" — and a failed fetch would
             leave that lie on screen for good. -->
        @if (getCurrentUser() && !isFreeSession()) {
          @if (onSitePaymentState === 'loading') {
            <div class="loading-inline">
              <span class="spinner-small"></span>
              <span>Zahlungsoptionen werden geladen...</span>
            </div>
          } @else if (onSitePaymentState === 'error') {
            <div class="error-message error-message-actionable" role="alert">
              <span>{{ sessionLoadError }}</span>
              <button type="button" class="btn btn-ghost btn-sm"
                      (click)="loadOnSitePaymentAvailability()">
                Erneut versuchen
              </button>
            </div>
          } @else {
            <app-payment-section
              [totalPrice]="getSessionPrice()"
              [organizationId]="getOrganizationId()"
              [clientSecret]="stripeClientSecret || undefined"
              [paymentIntentId]="stripePaymentIntentId || undefined"
              [description]="getPaymentDescription()"
              [onSitePaymentEnabled]="onSitePaymentEnabled"
              [stripePaymentEnabled]="stripePaymentEnabled"
              [sepaPaymentEnabled]="sepaPaymentEnabled"
              [voucherPaymentEnabled]="voucherPaymentEnabled"
              [paypalPaymentEnabled]="paypalPaymentEnabled"
              [paypalClientId]="paypalClientId"
              [paypalEnvironment]="paypalEnvironment"
              [paypalOrderContext]="paypalOrderContext"
              (providerOwnsSubmit)="onProviderOwnsSubmit($event)"
              (paymentMethodChanged)="onPaymentMethodChanged($event)"
              (paymentSuccess)="onPaymentSuccess($event)"
              (paymentError)="onPaymentError($event)"
              (voucherCalculationChanged)="onVoucherCalculationChanged($event)"
              (fullyCoveredByVouchersChanged)="onFullyCoveredByVouchersChanged($event)"
              (selectedVoucherCodesChanged)="onSelectedVoucherCodesChanged($event)"
              [locked]="isProcessing"
              (voucherCalculationPendingChanged)="voucherCalculationPending.set($event)"
              (confirmFnReady)="onConfirmFnReady($event)"
              (paymentFormComplete)="onPaymentFormComplete($event)">
            </app-payment-section>
          }
        }

        <!-- Loading enrollment intent -->
        @if (intentLoading()) {
          <div class="loading-inline">
            <span class="spinner-small"></span>
            <span>Zahlungsdetails werden geladen...</span>
          </div>
        }

        <!-- Intent error -->
        @if (intentError()) {
          <div class="error-message">
            {{ intentError() }}
          </div>
        }

        <!-- Error message -->
        @if (processingError) {
          <div class="error-message">
            {{ processingError }}
          </div>
        }
      </div>

      <!-- Form Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-ghost" (click)="onCancel()">Abbrechen</button>
        <!-- Hidden while PayPal is selected: the PayPal SDK renders its own
             submit button, and a second CTA beside it would either do nothing
             or start a parallel enrollment. -->
        @if (!isSubmitOwnedByProvider()) {
          <button type="submit" class="btn btn-primary" (click)="onSubmit()"
                  [disabled]="isConfirmButtonDisabled()">
            @if (isProcessing) {
              <span class="spinner"></span>
              Wird verarbeitet...
            } @else {
              {{ isFullyCoveredByVouchers() ? 'Mit Gutschein anmelden' : 'Anmeldung bestätigen' }}
            }
          </button>
        }
      </div>
    }

    <!-- Success Step -->
    @if (step() === 'success') {
      <div class="modal-content">
        <div class="success-section">
          <div class="success-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
          </div>
          @if (waitlisted()) {
            <h2>Auf der Warteliste</h2>
            @if (waitlistPosition()) {
              <p>Diese Session ist ausgebucht. Sie stehen auf Platz {{ waitlistPosition() }} der Warteliste und rücken automatisch nach, sobald ein Platz frei wird.</p>
            } @else {
              <p>Diese Session ist ausgebucht. Sie stehen auf der Warteliste und rücken automatisch nach, sobald ein Platz frei wird.</p>
            }
          } @else {
            <h2>Erfolgreich angemeldet!</h2>
            <p>Ihre Anmeldung wurde erfolgreich erstellt.</p>
          }

          <div class="success-summary">
            <div class="summary-row">
              <span class="summary-label">{{ kindLabel }}</span>
              <span class="summary-value">{{ session.displayName }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Datum</span>
              <span class="summary-value">{{ formatDate(getSessionStartTime()) }}</span>
            </div>
            <div class="summary-row">
              <span class="summary-label">Uhrzeit</span>
              <span class="summary-value">{{ formatTime(getSessionStartTime()) }} - {{ formatTime(getSessionEndTime()) }}</span>
            </div>
            @if (getCourtNames(session)) {
              <div class="summary-row">
                <span class="summary-label">{{ session.courts && session.courts.length > 1 ? 'Plätze' : 'Platz' }}</span>
                <span class="summary-value">{{ getCourtNames(session) }}</span>
              </div>
            }
            <div class="summary-row">
              <span class="summary-label">Preis</span>
              <span class="summary-value price-highlight">
                @if (isFreeSession()) {
                  Kostenlos
                } @else {
                  {{ getSessionPrice() | currency:'EUR':'symbol':'1.2' }}
                }
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Success Actions -->
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Schließen</button>
        <button type="button" class="btn btn-primary" (click)="goToMyCourses()">Meine Kurse</button>
      </div>
    }
  </div>
</div>
